<template>
<v-container fluid class="grey lighten-4">
  <v-row >
    <v-col cols="12" class="text-right">
      <v-btn color="green" dark @click="save" v-if="modified">Save</v-btn>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" md="10">
      <v-text-field label="Description (internal)" v-model="item.description"></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-switch :true-value="1" :false-value="0" label="Active" v-model="item.active" color="green"></v-switch>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Title" v-model="item.headline"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea outlined label="Text" :rows="5" v-model="item.message"></v-textarea>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Link" v-model="item.action_url"></v-text-field>
    </v-col>
  </v-row>


</v-container>
</template>
<script>
export default {
  props: ['value'],
  name: "",
  data: () => ({
    modified: false
  }),
  created() {

  },
  beforeDestroy() {

  },
  watch: {
    'item': {
      handler: function(to, from) {
        if (to && from) {
          this.modified = true
        }
      },
      deep: true
    }
  },
  computed: {
    item() {
      return this.value
    }
  },
  methods: {
    async save() {
      await this.$api({
        method: "PATCH",
        url: `/admin/notification-templates/${this.item.id}`,
        data: this.item
      })
      setTimeout(function() {
        this.modified = false
      }.bind(this), 100)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
